import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
  dsn: "https://fceb81183dad02796e03d41227008b6a@o4506740089225216.ingest.us.sentry.io/4511298122743808",
  enabled: environment.production,
  sendDefaultPii: true
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
